// whatsapp share
// https://stackoverflow.com/questions/21935149/sharing-link-on-whatsapp-from-mobile-website-not-application-for-android
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import SelectionTab from '../../../../../../components/ZUILib/SelectionTab';
import Link from '../../../../../../components/ZUILib/Link';
import Template1 from './template1';
import Template2 from './template2';
import ModalPopover from '../../../../../../components/ZUILib/ModalPopover';
import TextInput from '../../../../../../components/ZUILib/TextInput';
import * as giftListActions from '../../actions';
import * as defaultConst from '../../../../../../utils/clientConstant';
import pdfUtil from '../../../../../../utils/PDFUtil';
import commonUtil from '../../../../../../utils/commonUtil';
import DownloadPDFWithoutPreview from '../../../../../../components/DownloadPDFWithoutPreview';
import serverClientUtil from '../../../../../../utils/serverClientUtil';
import _ from 'lodash';
import EmptyGiftListIndicator from '../../components/EmptyGiftListIndicator';
import TableHead from './tableHead';
import ReactWebShare from '../../../../../../components/ReactWebShare';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import RadioButton from '../../../../../../components/ZUILib/RadioButton';
import Warning2 from '../../../../../../components/Warning2';

const {
  removeItemsFromGiftlist,
  handleRemoveItemsFromGiftlist,
  handleChangeDeliveryAddress,
  changeDeliveryAddress,
  handleChangeDeliveryMode,
  changeDeliveryMode,
  getRegisteredGiftList,
} = giftListActions;
const pageName = 'lista-de-regalos';

const applicationRoutes = commonUtil.getApplicationRoutes();
const predefinedStatus = defaultConst.RESTRICTED_EVENT_STATUSES;
const hideSelectionDropDownStatus = [defaultConst.eventStatus.VALIDITY_OFF_ACTIVE];

class RegalosRegistradosContent extends Component {
  constructor(props) {
    // this.sortType = {};
    super(props);
    this.checkMyCheckBox = false;
    this.state = {
      modalId: '',
      seletedOption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
      sortingType: '',
      searchKeyword: '',
      isGiftSelected: false,
      registeredGiftList: this.props.registeredGiftList,
      deliveryAddressInfo: this.props.registeredGiftList.deliveryAddressInfo,
      searchFlag: true,
      confirmationMessage: '',
      actionType: '',
      addressSelected: '',
      modeSelected: '',
      categoryInfo: [],
      originalRegisteredGiftList: _.isObject(props.originalRegisteredGiftList)
        ? props.originalRegisteredGiftList
        : { categoryItemsInfo: [], deliveryAddressInfo: [], itemsInfo: [], links: [], certificateItemsInfo: [] },
      shouldDownloadPdf: false,
    };
    document.addEventListener('click', this.closeDropdownOptionsOnOutsideClick);
    this.initialRegisteredGiftList = props.initialRegisteredGiftList || {};
  }
  isChanged = false
  isRenderedOnce = true
  electronicItemsIds = []
  registeredGiftList = []
  deliveryAddressInfo = []
  selectedGift = []
  sortType = {};
  searchedValue = '';
  selectedType = false;

  componentWillUnmount() {
    document.removeEventListener('click', this.closeDropdownOptionsOnOutsideClick);
  }

  UNSAFE_componentWillMount() {
    if (document && typeof document !== 'undefined') {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://platform.twitter.com/widgets.js';
      document.body.appendChild(script);
    }
    // if (this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.CLOSED) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITYOFFACTIVE)) {
    //   document.querySelector('#configDiv').style.display = 'none';
    //   document.querySelector('#selectionTodos').style.display = 'none';
    // }
  }
  
  componentDidUpdate(prevProps) {
    const finishedLoading =
      prevProps.loadingAllRegisteredGifts &&
      !this.props.loadingAllRegisteredGifts;
  
    if (this.state.shouldDownloadPdf && finishedLoading) {
      this.setState({ shouldDownloadPdf: false }, () => {
        this.generateAndDownloadPdf();
      });
    }
  }

  handlePDFDownload = () => {
    if (this.props.categoryDepartmentId.length === 0) {
      this.setState({ shouldDownloadPdf: true }, () => {
        this.props.getPaginatedRegisteredGifts(undefined, true);
      });
    } else {
      this.generateAndDownloadPdf();
    }
  };

  generateAndDownloadPdf = () => {
    const downloadableContent = (<DownloadPDFWithoutPreview isMsgGiftListPdf={false} pageName printingDate={this.props.printingDate} download>
      <Template2
        categoryInfo={this.props.categoryDepartmentId.length === 0 ? this.props.allRegisteredGifts.categoryItemsInfo : this.state.categoryInfo}
        lables={this.props.lables}
        registeredGiftList={this.state.registeredGiftList}
        eventDate={this.props.eventDate}
        eventId={this.props.eventId}
        eventType={this.props.eventType}
        giftCount={this.props.giftCount}
      /> </DownloadPDFWithoutPreview>);
    pdfUtil.attachToDom(downloadableContent, pageName);
  }

  handlePrint = () => {
    const printContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate}><Template2 categoryInfo={this.state.categoryInfo} lables={this.props.lables} registeredGiftList={this.state.registeredGiftList} eventDate={this.props.eventDate} eventId={this.props.eventId} eventType={this.props.eventType} giftCount={this.props.giftCount} /></DownloadPDFWithoutPreview>);
    pdfUtil.attachToDomForPrint(printContent, pageName);
  }
  giftSettingsSelect = () => {
    const one = document.querySelector('#selectAll');
    if (one.className === 'selectAll btn-group') {
      document.querySelector('#selectAll').classList.add('open');
    } else {
      one.classList.remove('open');
    }
  }

  selectAllGifts = (e) => {
    const { itemsInfo: registeredGifts = [], certificateItemsInfo: registeredGiftCertificates = [] } = this.state.originalRegisteredGiftList;
    const allRegisteredItems = [...registeredGifts, ...registeredGiftCertificates];
    this.selectedGift = [];
    if (e.checked) {
      allRegisteredItems.forEach((registeredGift) => {
        this.selectedGift.push(registeredGift);
      });
    }

    this.checkMyCheckBox = e.checked;

    this.setState({
      ...this.state,
      seletedOption: e.checked ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label') : commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
      isGiftSelected: this.selectedGift.length && true,
    });
    this.showHidden(this.selectedGift.length && true);
  }
  showHidden = (isChecked) => {
    const items = [
      document.getElementsByClassName('col-sm-5 editButtons')[0],
      document.getElementsByClassName('col-sm-5 editButtons 2')[0],
      document.getElementsByClassName('editButtons addEditLink size-Smallest')[0],
    ];
    const existingItems = _.pickBy(items, item => !_.isNil(item));
    if (_.isEmpty(existingItems)) return;

    if (isChecked === true) {
      // const show = document.getElementsByClassName('col-sm-5 editButtons')[0].style.display;
      // const showSelect = document.getElementsByClassName('col-sm-5 editButtons 2')[0].style.display;
      // const remove = document.getElementsByClassName('editButtons addEditLink size-Smallest')[0].style.display;

      const show = document.getElementById('todosFilter').style.display;
      if (show === 'none') {
        //document.getElementsByClassName('col-sm-4 invitedListSearch pr-0')[0]?.classList.replace('col-sm-4', 'col-sm-3');
       // document.getElementsByClassName('col-sm-4 invitedListConfig pr-0')[0]?.classList.replace('col-sm-4', 'col-sm-7');
        // document.getElementsByClassName('col-sm-5 editButtons')[0].style.display = 'block';
        // document.getElementsByClassName('col-sm-5 editButtons 2')[0].style.display = 'block';
        // document.getElementsByClassName('editButtons addEditLink size-Smallest')[0].style.display = 'block';
        document.getElementById('todosFilter').style.display = 'block';
      }
    } else {
      //document.getElementsByClassName('col-sm-3 invitedListSearch pr-0')[0]?.classList.replace('col-sm-3', 'col-sm-4');
      //document.getElementsByClassName('col-sm-7 invitedListConfig pr-0')[0]?.classList.replace('col-sm-7', 'col-sm-4');
      // document.getElementsByClassName('col-sm-5 editButtons')[0].style.display = 'none';
      // document.getElementsByClassName('col-sm-5 editButtons 2')[0].style.display = 'none';
      // document.getElementsByClassName('editButtons addEditLink size-Smallest')[0].style.display = 'none';
      document.getElementById('todosFilter').style.display = 'none';
    }
  }
  selectedOption = (event) => {
    // const { lables } = this.props;
    const category = event.currentTarget.name;
    this.selectedGift = [];
    const { itemsInfo: registeredGifts = [], certificateItemsInfo: registeredGiftCertificates = [] } = this.state.originalRegisteredGiftList;
    const allRegisteredItems = [...registeredGifts, ...registeredGiftCertificates];
    allRegisteredItems.forEach((item) => {
      const ele = item;
      ele.checked = false;
      if (item.deliveryMode === category) {
        ele.checked = true;
        this.selectedGift.push(ele);
        this.showHidden(this.selectedGift.length && true);
        this.selectedType = true;
      }
      if ((item.availability === 'true' || item.availability) && category === 'Disponible') {
        ele.checked = true;
        this.selectedGift.push(ele);
        this.showHidden(this.selectedGift.length && true);
      }
      //  if (!item.availability && this.props.compareEventStatus(category, 'notDisponible')) {
      if ((item.availability === 'false' || !item.availability) && category === 'notDisponible') {
        ele.checked = true;
        this.selectedGift.push(ele);
        this.showHidden(this.selectedGift.length && true);
      }
      if (category === 'selectAll') {
        ele.checked = false;
        this.showHidden(false);
      }
    });
    this.checkMyCheckBox = true;
    if (category === 'selectAll') {
      this.checkMyCheckBox = false;
    } else {
      this.checkMyCheckBox = true;
    }
    this.setState({
      seletedOption: event.currentTarget.title,
      isGiftSelected: this.selectedGift.length && true,
    });

    document.querySelector('#selectAll').classList.remove('open');
  }
  handleGiftUnselect = (gift) => {
    const categoryItemsInfo = JSON.parse(JSON.stringify(this.state.categoryInfo));
    categoryItemsInfo.forEach((cat) => {
      cat.itemInfo.forEach((item) => {
        if (item.giftItemId === gift.giftItemId) {
          const ele = item;
          ele.checked = false;
        }
      });
    });
    let newTempArray = [];
    newTempArray = this.selectedGift.filter(item => item.giftItemId !== gift.giftItemId);
    this.selectedGift = newTempArray;
    this.setState({
      ...this.state,
      isGiftSelected: this.selectedGift.length && true,
      categoryInfo: categoryItemsInfo,
    });
    this.showHidden(this.selectedGift.length && true);
  }
  handleGiftSelection = (gift) => {
    const categoryItemsInfo = JSON.parse(JSON.stringify(this.state.categoryInfo));
    categoryItemsInfo.forEach((cat) => {
      cat.itemInfo.forEach((item) => {
        if (item.giftItemId === gift.giftItemId) {
          const ele = item;
          ele.checked = true;
        }
      });
    });
    this.selectedGift.push(gift);
    this.setState({
      ...this.state,
      isGiftSelected: this.selectedGift.length && true,
      categoryInfo: categoryItemsInfo,
    });
    this.showHidden(this.selectedGift.length && true);
  }
  removeItemsFromGiftlist = () => {
    this.setState({ actionType: 'delete', confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.delete.product.confirmation.popup.message') });
    this.setModalId('modalDelete');
    this.confirmationModalForUpdate.handleShow();
  };
  dismissDelete = () => {
    this.confirmationModalForUpdate.handleHide();
    document.querySelector('#deliveryAddress').selectedIndex = 0;
    document.querySelector('#deliveryMode').selectedIndex = 0;
  }

  confirmAction = () => {
    if (this.state.actionType === 'delete') {
      this.confirmDelete();
    } else if (this.state.actionType === 'address') {
      this.confirmAddressChange(this.state.addressSelected);
    } else if (this.state.actionType === 'mode') {
      this.confirmModeChange(this.state.modeSelected);
    }
  }

  confirmDelete = () => {
    const removeGiftItems = [];
    for (let i = 0; i < this.selectedGift.length; i++) {
      removeGiftItems.push(this.selectedGift[i].giftItemId);
    }
    // Get the current priceOrder from state
    const currentPriceOrder = this.state?.originalRegisteredGiftList?.priceOrder || 'Ascending';
    
    handleRemoveItemsFromGiftlist(this.props.eventId, removeGiftItems).then((response) => {
      this.isChanged = false;
      if (response.body.status.status === 'success') {
        // JSON.parse(JSON.stringify(this.props.handleBulkAction(response.body, 'remove', removeGiftItems)));
        this.props.getRegisteredGiftList(this.props.eventId, currentPriceOrder, '', '', '', true, this.props.categoryDepartmentId);
        this.isChanged = false;
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        this.showHidden(false);
        this.checkMyCheckBox = false;
         this.props.deletePopup.setMessage(commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.delete.article.element.gift.list'));
        // this.selectedGift = [];
      }
    }).catch((e) => { console.log(e); }); // console required
  }
  changeDeliveryAddressOption = (selectedAddress) => {
    this.setState({ confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.change.delivery.address.confirmation.popup.message'), actionType: 'address', addressSelected: selectedAddress });
    this.setModalId('modalChangeDir');
    setTimeout(() => { this.confirmationModalForUpdate.handleShow(); }, 300);
  }


  confirmAddressChange = (selectedAddress) => {
    const changeAddressGiftItems = [];
    for (let i = 0; i < this.selectedGift.length; i++) {
      if (this.selectedGift[i].deliveryMode === 'physical') {
        changeAddressGiftItems.push(this.selectedGift[i].giftItemId);
      }
    }
    handleChangeDeliveryAddress(this.props.eventId, changeAddressGiftItems, selectedAddress.deliveryAddressId).then((response) => {
      if (response.body.status.status === 'success') {
        this.props.handleBulkAction(response.body.categoryItemsInfo, 'addressChange');
        this.isChanged = false;
        this.confirmationModalForUpdate.handleHide();
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.updateRegisteredGift(itemInfo));
        this.selectedGift = [];
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        this.showHidden(false);
        this.checkMyCheckBox = false;
        document.querySelector('#boxSquareAll').checked = false;
      }
    }).catch((e) => { console.log(e); }); // console required
    document.querySelector('#deliveryAddress').selectedIndex = 0;
    // this.showHidden(false);
  }
  deliveryAddressOptions = (deliveryAddressInfo) => {
    const lookup = {};
    const items = deliveryAddressInfo;
    const result = [];
    let i = 0;
    /* eslint-disable */
    for (let item; item = items[i++];) {
      const deliveryAddressInfo = item.deliveryAddressName;
      const deliveryAddressId = item.deliveryAddressId;
      if (!(deliveryAddressId in lookup)) {
        lookup[deliveryAddressId] = 1;
        // lookup[deliveryAddressId] = 1;
        result.push({
          id: deliveryAddressId,
          value: deliveryAddressInfo,
          labelResourceId: deliveryAddressInfo,
          disabled: false,
        });
      }
    }
    /* eslint-enable */
    return result;
  }
  storeElectronicGifts = (electronicGifts) => {
    this.electronicItemsIds = electronicGifts.itemInfo;
  }
  changeDeliveryModeOption = (selectedMode) => {
    this.setState({ confirmationMessage: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.registrados.change.delivery.mode.confirmation.popup.message'), actionType: 'mode', modeSelected: selectedMode });
    this.setModalId('modalChangeMod');
    setTimeout(() => { this.confirmationModalForUpdate.handleShow(); }, 300);
  }

  confirmModeChange = (selectedMode) => {
    const tempSelectedGift = [];
    for (let i = 0; i < this.selectedGift.length; i++) {
      if (this.electronicItemsIds.length) {
        for (let j = 0; j < this.electronicItemsIds.length; j++) {
          if (+(this.selectedGift[i].giftItemId) === +(this.electronicItemsIds[j].giftItemId)) {
            break;
          }
          if (+(this.selectedGift[i].giftItemId) !== +(this.electronicItemsIds[j].giftItemId) && j === this.electronicItemsIds.length - 1) {
            tempSelectedGift.push(this.selectedGift[i].giftItemId);
          }
        }
      } else {
        tempSelectedGift.push(this.selectedGift[i].giftItemId);
      }
    }

    handleChangeDeliveryMode(this.props.eventId, tempSelectedGift, '', [], selectedMode.id).then((response) => {
      if (response.body.status.status === 'success') {
        this.props.handleBulkAction(response.body.categoryItemsInfo, 'modeChange');
        this.isChanged = false;
        this.checkMyCheckBox = false;
        if (this.selectedType === true) {
          this.setState({
            ...this.state,
            seletedOption: this.props.lables ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label') : 'Seleccionar todos',
          });
        }
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.updateRegisteredGift(itemInfo));
        if (itemsInfo?.length === 0) {
          const selectAllBox = document.querySelector('#boxSquareAll');
          if (selectAllBox) selectAllBox.checked = false;
        }
        this.selectedGift = [];
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
        this.showHidden(false);
        this.checkMyCheckBox = false;
      }
    }).catch((e) => { 
      console.log(e); 
      this.props.handleBulkAction(e.body, 'modeChange');
       this.isChanged = false;
        this.checkMyCheckBox = false;
       this.selectedGift = [];
        document.querySelectorAll('input[name=checkboxGift]:checked').forEach((item) => { const ele = item; ele.checked = false; });
       this.showHidden(false);
       this.checkMyCheckBox = false;
       this.warning.setMessage(e.body?.detail ||e.body?.message);
    }); // console required
    document.querySelector('#deliveryMode').selectedIndex = 0;
    // this.showHidden(false);
  }


  isNotEmpty = obj => obj !== undefined && JSON.stringify(obj) !== JSON.stringify({})
  updateGiftList = (giftItemId, skuId, isFavourite, quantity) => {
    const categoryItemsInfo = JSON.parse(JSON.stringify(this.state.categoryInfo));
    categoryItemsInfo.forEach((cat) => {
      cat.itemInfo.forEach((itm) => {
        const item = itm;
        if (item.giftItemId === giftItemId) {
          item.isFavourite = isFavourite;
          item.quantity = quantity;
        }
      });
    });
    this.setState({
      ...this.state,
      categoryInfo: categoryItemsInfo,
    });
  }
  componentWillReceiveProps(nextProps) {
    const prevOriginalRegisteredGiftList = this.props.originalRegisteredGiftList;
    const nextOriginalRegisteredGiftList = nextProps.originalRegisteredGiftList;
    const originalRegisteredGiftListDidChange = prevOriginalRegisteredGiftList !== nextOriginalRegisteredGiftList;
    if (originalRegisteredGiftListDidChange) {
      this.setState({ originalRegisteredGiftList: nextOriginalRegisteredGiftList });
      this.checkMyCheckBox = false;
      this.selectedGift = [];
      this.showHidden(false);
    }

    if (!this.isChanged && !commonUtil.isObjectEmpty(nextProps.registeredGiftList)) {
      this.isChanged = true;
      this.categoryInfo = nextProps.categoryInfo;
      this.registeredGiftList = nextProps.registeredGiftList ? nextProps.registeredGiftList : [];
      this.deliveryAddressInfo = nextProps.registeredGiftList && nextProps.registeredGiftList.deliveryAddressInfo ? nextProps.registeredGiftList.deliveryAddressInfo : [];
      this.setState({
        registeredGiftList: this.registeredGiftList,
        deliveryAddressInfo: this.deliveryAddressInfo,
        categoryInfo: this.categoryInfo,
      });
    } else if (!nextProps.loadingRegisteredGifts) {
      this.categoryInfo = nextProps.categoryInfo;
      this.setState({
        categoryInfo: this.categoryInfo,
      });
    }
    this.confirmationModalForUpdate.handleHide();
  }


  openShareModal = () => {
    this.props.shareModal.handleShow();
  }
  getCategorytable = (template, linkJSON, LinkJSONPrice, categoryName) => {
    const temp = (
      <React.Fragment>

        {(categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') ?
          <React.Fragment>
            <div className="col-md-6 mt-2">
              <p className="categoryTag"><span className="catTitle">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.label')}:</span> Certificado Electrónico</p>
            </div>
            <div className="col-md-6 mt-2">
              <p className="categoryTag text-right"><span className="catTitle">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.giftcertificates.notes.label')}</span></p>
            </div>
          </React.Fragment>
          :
          <div className="col-md-12">
            <p className="categoryTag"><span className="catTitle">{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.category.label')}:</span>{categoryName}</p>
          </div>}
        <div className="col-md-12">
          <table className="tableRegisteredGifts">
            <tbody>
              {template}
            </tbody>
          </table>
        </div>
      </React.Fragment>);
    return temp;
  }
  setLocalData = () => {
    if (this.registeredGiftList.length && this.deliveryAddressInfo.length) {
      this.isRenderedOnce = false;
      this.setState({
        registeredGiftList: this.registeredGiftList,
        deliveryAddressInfo: this.deliveryAddressInfo,
      });
    }
  }
  makeIsChangeFalse = () => {
    this.isChanged = false;
  }

  clearSearch = () => {
    this.makeIsChangeFalse();
    this.selectAllGifts({ checked: false });
    this.setState({ searchKeyword: '', searchFlag: true });
    this.props.handleSortAndFilter('Ascending', '', '');
    this.isChanged = false;
    this.searchGift = '';
    document.getElementById('searchArea').value = '';
  }
  onSearchAreaKeyUp = (e) => {
    if (e.keyCode === 13) {
      // Service Call
      this.selectAllGifts({ checked: false });
      this.setState({ searchKeyword: this.searchGift.getValue(), searchFlag: false });
      this.makeIsChangeFalse();
      this.props.handleSortAndFilter('Ascending', this.searchGift.getValue(), '');
      this.isChanged = false;
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.setState({ searchFlag: true });
      this.props.handleSortAndFilter('Ascending', '', '');
    }
  }
  onClickSearchResult=() => {
    // this.makeIsChangeFalse();
    this.selectAllGifts({ checked: false });
    this.setState({ searchKeyword: this.searchGift.getValue(), searchFlag: false });
    this.props.handleSortAndFilter('Ascending', this.searchGift.getValue(), '');
    this.isChanged = false;
    this.searchedValue = this.searchGift.getValue();
  }
  setModalId = (id) => {
    this.setState({ modalId: id });
  }

  updateRegisteredGift = (registeredGift) => {
    const allowedProperties = _.pick(registeredGift, [
      'addressId',
      'availability',
      'catalogRedirectionURL',
      'categoryName',
      'deliveryMode',
      'departmentId',
      'desc',
      'giftItemId',
      'imageURL',
      'isFavourite',
      'listPrice',
      'name',
      'productId',
      'productType',
      'quantity',
      'salePrice',
      'skuId',
      'sortPrice',
    ]);
    const definedProperties = _.pickBy(allowedProperties, giftDetail => !_.isNil(giftDetail));
    if (_.isNil(definedProperties.giftItemId)) throw new Error('giftItemId has to be defined');
    const itemsInfo = this.state.originalRegisteredGiftList.itemsInfo.map((itemInfo) => {
      if (itemInfo.giftItemId === definedProperties.giftItemId) return { ...itemInfo, ...definedProperties };
      return { ...itemInfo };
    });
    const certificateItemsInfo = _.get(this.state, 'originalRegisteredGiftList.certificateItemsInfo', []).map((itemInfo) => {
      if (itemInfo.giftItemId === definedProperties.giftItemId) return { ...itemInfo, ...definedProperties };
      return { ...itemInfo };
    });
    const originalRegisteredGiftList = { ...this.state.originalRegisteredGiftList, itemsInfo, certificateItemsInfo };
    this.setState({ originalRegisteredGiftList });
  }

  closeDropdownOptionsOnOutsideClick = (clickEvent) => {
    const dropdownOptions = document.getElementById('dropdown-options');
    const dropdownToggle = document.getElementById('dropdown-toggle');

    const elementsNotFound = _.isNil(dropdownOptions) || _.isNil(dropdownToggle);
    const clickedInsideDropdown =
      dropdownOptions.contains(clickEvent.target) || dropdownToggle.contains(clickEvent.target);
    const dropdownAlreadyHidden = !dropdownOptions.checkVisibility();
    if (elementsNotFound || clickedInsideDropdown || dropdownAlreadyHidden) return;

    dropdownToggle.click();
  };

  render() {
    const {
      itemsInfo: registeredGifts = [],
      itemsCount: totalRegisteredGifts,
      certificateItemsInfo: registeredGiftCertificates = [],
      totalRecordsShowed,
      searchKeyword = '',
      priceOrder = 'Ascending',
    } = this.state.originalRegisteredGiftList;
    // const registeredGifts = [];
    // const registeredGiftCertificates = [];
    // const searchKeyword = 'value';
    const listIsEmpty = registeredGifts.length <= 0 && registeredGiftCertificates.length <= 0;
    const currentBrandColors = commonUtil.getCurrentBrandColors();

    // will check for isDownloadPage state in redux to get the recoreds from the respective state.
    // const socialSharePath = `http://grdev.liverpool.com.mx:3000${this.props.location}`;
    const lables = this.props.lables;
    const CambiarModoDeRegalos = {
      id: 'deliveryMode',
      disable: false,
      defaultValue: '',
      options: [{
        id: defaultConst.constGiftDeliveryMode.Físicos,
        value: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
        labelResourceId: 'Físicos',
        disabled: false,
      }, {
        id: defaultConst.constGiftDeliveryMode.Electrónicos,
        value: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
        labelResourceId: 'Electrónicos',
        disabled: false,
      }],
    };
    const CambiarDirección = {
      id: 'deliveryAddress',
      disable: false,
      defaultValue: '', // deliveryAddressInfo.addressName
      options: this.isNotEmpty(this.state.registeredGiftList.deliveryAddressInfo) ? this.state.registeredGiftList.deliveryAddressInfo : [],
    };
    const linkJSON1 = {
      route: '',
    };
    let isDisabled = false;
    if (this.props.compareEventStatus(this.props.eventStatus, predefinedStatus)) {
      isDisabled = true;
    }
    // const isDisabled = this.props.eventStatus === 'Admin Process' || this.props.eventStatus === 'Suspended' || this.props.eventStatus === 'Validity off Active' || this.props.eventStatus === 'Temporary Closed' || this.props.eventStatus === 'Closed';
    const { registeredGiftList } = this.state;

    // this.allCategoryInfo = this.props.allCategoryInfo;
    // const { categoryInfo, allCategoryInfo } = this.props;
    const totalRecords = registeredGiftList.totalRecords ? registeredGiftList.totalRecords : 0;
    let loadedRecordCount = 0;
    if (this.state.categoryInfo.length) {
      this.state.categoryInfo.forEach((item) => {
        const itemCount = item.itemInfo ? item.itemInfo.length : 0;
        loadedRecordCount += itemCount;
      });
    }
    if (!this.state.categoryInfo.length && this.props.categoryInfo.length) {
      this.setState({
        categoryInfo: this.props.categoryInfo,
      });
    }
    const currentPage = this.props.registeredGiftList ? this.props.registeredGiftList.currentPage : 0;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType('tabregistered', totalRecords, loadedRecordCount, sortType, currentPage);
    const categoryInfoToRender = this.state.categoryInfo.length ? this.state.categoryInfo : [];
    const modalFooter = (<div className="modal_buttons">
      <button className="btnSecondaryAction size-Small" onClick={this.dismissDelete}>Cancelar</button>
      <button className="btnPrimaryAction size-Small" onClick={this.confirmAction}>Aceptar</button>
    </div>);

    let registeredItemsFound = registeredGifts.length > 0 || registeredGiftCertificates.length > 0;

    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton',
      value: priceOrder === 'Ascending' ? commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.label'):commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.label'),
      disabled: !registeredItemsFound,
      cssStyle: { opacity: registeredItemsFound ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      imageClass: commonUtil.getAssetURL() + '/images/expand_more.svg'
    };


    const LinkJSONPrice = {
      href: 'javascript:void(0);',
      displayName: '',
      onClickHandler: () => {
        const show = document.getElementsByClassName('giftList-sort-modal')[0].style.display;
        if(show === 'none'){
          document.getElementsByClassName('giftList-sort-modal')[0].style.display = 'block';
        }else{
          document.getElementsByClassName('giftList-sort-modal')[0].style.display = 'none';
        }
      },
    };


    const handleSwitchRadio = (ref, event) => {
      this.props.getPaginatedRegisteredGifts({
        priceOrder: priceOrder === 'Ascending' ? 'Descending' : 'Ascending',
      });
      document.getElementsByClassName('giftList-sort-modal')[0].style.display = 'none';
    }

    const modalLink = (
      <a onClick={registeredItemsFound ? this.props.setCopyToClipboard : undefined}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_351_57579)">
            <path d="M16 5L14.58 6.42L12.99 4.83V16H11.01V4.83L9.42 6.42L8 5L12 1L16 5ZM20 10V21C20 22.1 19.1 23 18 23H6C4.89 23 4 22.1 4 21V10C4 8.89 4.89 8 6 8H9V10H6V21H18V10H15V8H18C19.1 8 20 8.89 20 10Z" fill="black"/>
          </g>
          <defs>
            <clipPath id="clip0_351_57579">
              <rect width="24" height="24" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </a>
    );

    const priceSorting = [{
      "id": 'Ascending',
      "value": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.ascending')
    }, {
      "id": 'Descending',
      "value": commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.descending')
    }
    ]


    return (
      <div className="row">
        <div className="col-sm-12">
          <Warning2
            type="error"
            onClose
            notSetToTop
            style={{ backgroundColor: '#E7F8EC', marginBottom: '20px' }}
            text={this.errorMessage}
            ref={warning => this.warning = warning}
          />
        {(!listIsEmpty || !_.isEmpty(searchKeyword)) && (
          <div className="row invitedListGiftRegister">
            {/* {this.props.compareEventStatus(this.props.eventStatus, hideSelectionDropDownStatus) ? '' :
            <div className="col-sm-12 pl-0" id="configDiv" style={{ display: 'block' }}>
              <label>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.configuration.label')}</label>
            </div>
            } */}

               {!listIsEmpty ? <div className="col-sm-4 invitedListConfig pr-0">
                {this.props.compareEventStatus(this.props.eventStatus, hideSelectionDropDownStatus) ? '' :
                  <Fragment>
                    <div className='col-xs-4'>
                      <div id="selectionTodos" >
                        <div id="selectAll" className="selectAll btn-group">
                          <div className="labelListDown-10" type="button">
                            <CheckBox
                              displayName={this.state.seletedOption}
                              checked={this.checkMyCheckBox}
                              id="boxSquareAll"
                              name="check"
                              checkStatus="false"
                              getSelectedValue={this.selectAllGifts}
                              disabled={isDisabled}
                            />
                          </div>

                          <button id="dropdown-toggle" className="btn btn-default dropdown-toggle btnBasicSlidedown" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={this.giftSettingsSelect} disabled={isDisabled} ><i className="icon-caret_down" /><span className="sr-only">Toggle Dropdown</span></button>
                          {isDisabled ? null : <ul className="dropdown-menu" id="dropdown-options" >
                            <li name="selectAll"><a onClick={this.selectedOption} name="selectAll" href="javascript:void(0)" title={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label')}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.any.label')}</a></li>
                            <li name="physical"><a onClick={this.selectedOption} name="physical" href="javascript:void(0)" title="Físicos">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.physical.label')}</a></li>
                            <li name="electronic"><a onClick={this.selectedOption} name="electronic" href="javascript:void(0)" title="Electrónicos">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.electronic.label')}</a></li>
                            <li name="Disponible"><a onClick={this.selectedOption} name="Disponible" href="javascript:void(0)" title="Disponible">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.available.label')}</a></li>
                            <li name="notDisponible"><a onClick={this.selectedOption} name="notDisponible" href="javascript:void(0)" title="No Disponible">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.notavailable.label')}</a></li>
                          </ul>}

                        </div>
                      </div>
                    </div>

                    {/* <div className='col-xs-8'>
                      <div id="todosFilter" className='row'  style={{ display: 'none'}}>
                        <div className="col-sm-5 editButtons" style={{ padding: '0', flex: 1 }}>
                          <SelectionTab
                            classname="cSelect filters"
                            id={CambiarDirección.id}
                            options={CambiarDirección.options}    // {this.state.registeredGiftList.deliveryAddressInfo}
                            optionCaption={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.category.dropdown.label')}
                            optionText={'deliveryOwnerName'}
                            optionValue={'deliveryAddressId'}
                            handleSelectedOption={this.changeDeliveryAddressOption}
                          />
                        </div>
                        <div className="col-sm-5 editButtons 2" style={{ padding: '0', flex: 1 }}>
                          <SelectionTab
                            classname="cSelect filters"
                            id={CambiarModoDeRegalos.id}
                            options={CambiarModoDeRegalos.options}
                            optionCaption={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.label')}
                            optionText={'labelResourceId'}
                            optionValue={'value'}
                            handleSelectedOption={this.changeDeliveryModeOption}
                          />
                        </div>
                        <div className="col-sm-2 pull-right" style={{ padding: '0', width: 'auto' }}><a className="editButtons addEditLink size-Smallest buttonDelete" href="javascript:void(0)" style={{ display: 'none' }} onClick={this.removeItemsFromGiftlist}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.elimination.buttton.label')}</a></div>
                      </div>
                    </div> */}
                  </Fragment>
                }
              </div> : <div className="col-sm-4"></div>}
            <div className="col-sm-4 invitedListSearch searchwrap">
              <div>
                <div className="input-group">
                  <TextInput
                    className="form-control"
                    htmlId="searchArea"
                    placeholder={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.search.message')}
                    required="true"
                    star=""
                    ref={txt => this.searchGift = txt}
                    onKeyUp={this.onSearchAreaKeyUp}
                  />
                  <span className="input-group-btn">
                    {this.state.searchFlag ?
                      <span className="btn btn-default buttonSearch" onClick={this.onClickSearchResult}>
                        <i className="icon-zoom" aria-hidden="true" /></span>
                      :
                      <span className="btn btn-default buttonSearch" onClick={this.clearSearch}>
                        <i className="iClass icon-tache2" aria-hidden="true" /></span>}
                  </span>
                </div>
              </div>
            </div>
            {!listIsEmpty ? <div className="col-sm-2 invitedListIcons pull-right">
              <span className='pull-right'>
                <a  onClick={() => this.handlePDFDownload()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM17 11L15.59 9.59L13 12.17V4H11V12.17L8.41 9.59L7 11L12 16L17 11Z" fill="#333333"></path>
                    </svg>
                </a>
                 {/* <ReactWebShare /> */}
                 {modalLink}
                {/* {this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) ? modalLink : <a> <i className="iClass icon-compartir" aria-hidden="true" /></a>} */}
              </span>
            </div>: <div className="col-sm-2"></div>}

              {!listIsEmpty &&<div className="col-xs-12 giftList-filters">
                <div className="row">
                  <div className='col-xs-7'>
                      <div id="todosFilter" className='row'  style={{ display: 'none'}}>
                        <div className="col-sm-5 editButtons">
                          <SelectionTab
                            classname="cSelect filters"
                            id={CambiarDirección.id}
                            options={CambiarDirección.options}    // {this.state.registeredGiftList.deliveryAddressInfo}
                            optionCaption={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.category.dropdown.label')}
                            optionText={'deliveryAddressName'}
                            optionValue={'deliveryAddressId'}
                            handleSelectedOption={this.changeDeliveryAddressOption}
                          />
                        </div>
                        <div className="col-sm-5 editButtons 2">
                          <SelectionTab
                            classname="cSelect filters"
                            id={CambiarModoDeRegalos.id}
                            options={CambiarModoDeRegalos.options}
                            optionCaption={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.label')}
                            optionText={'labelResourceId'}
                            optionValue={'value'}
                            handleSelectedOption={this.changeDeliveryModeOption}
                          />
                        </div>
                        <div className="col-sm-2 pull-right"><a className="editButtons addEditLink size-Smallest buttonDelete" href="javascript:void(0)" onClick={this.removeItemsFromGiftlist}>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.elimination.buttton.label')}</a></div>
                      </div>
                    </div>
                  <div className="col-xs-4 pull-right sort-container">
                    <div className='giftList-sort-div'>
                      <div className='giftList-sort'>
                        <Link linkJSON={LinkJSONPrice}>
                          <InputButton buttonAttr={SortArticleButton} />
                        </Link>
                      </div>
                      <div className="giftList-sort-modal" style={{ display: 'none' }}>
                        {priceSorting.map((option, index) => (
                          <div key={index} id={option.id} onClick={handleSwitchRadio} className={`sort-option ${priceOrder === option.id ? 'active' : ''}`}>
                            <span className="radio-icon" />
                            <span className="lable-txt">{option.value}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>


        )}
        {!listIsEmpty && (
          <div className="row productsCount">
            <div className="col-xs-12 regalosRegistrados-ProductsCount">
             <div className='text-right'>
               <b>{totalRecordsShowed} de {totalRegisteredGifts}</b> productos
             </div>
            </div>
          </div>
        )}

        {listIsEmpty && (
          <Fragment>
            <EmptyGiftListIndicator giftList={`${this.initialRegisteredGiftList.totalRecords == 0 ? 'registered': 'registered_noSearchResults'}`} style={{ padding: '3rem 0' }} />
            {/* <div className="row text-center" style={{ paddingBottom: '5rem' }}>
              <div className="col-xs-12">
                <a
                  style={{ color: currentBrandColors.primary, textDecoration: 'underline', cursor: 'pointer' }}
                  href={`#category-Grid`}
                >
                  Agregar regalos a mi lista
                </a>
              </div>
            </div> */}
          </Fragment>
        )}
          {
            registeredGifts.length > 0 || registeredGiftCertificates.length > 0 ? (
              <div className='miLisataDeRegalos'>
                <TableHead
                  lables={this.props.lables}
                />
              </div>
            ) : null
          }
        {registeredGifts.length > 0 &&
            <div className='registeredGifts'>
            <Template1
              updateGiftList={this.updateGiftList}
              sorting={this.props.sorting}
              storeElectronicGifts={this.storeElectronicGifts}
              makeIsChangeFalse={this.makeIsChangeFalse}
              handleGiftUnselect={this.handleGiftUnselect}
              handleGiftSelection={this.handleGiftSelection}
              registeredGiftList={this.state.registeredGiftList}
              isGiftSelected={this.state.isGiftSelected}
              eventId={this.props.eventId}
              handleSortAndFilter={this.props.handleSortAndFilter}
              eventStatus={this.props.eventStatus}
              categoryInfo={categoryInfoToRender}
              lables={this.props.lables}
              compareEventStatus={this.props.compareEventStatus}
              allowUpdate={this.props.allowUpdate}
              handleBulkAction={this.props.handleBulkAction}
              eventType={this.props.eventType}
              selectedGift={this.selectedGift}
              originalRegisteredGiftList={this.state.originalRegisteredGiftList}
              getPaginatedRegisteredGifts={this.props.getPaginatedRegisteredGifts}
              updateRegisteredGift={this.updateRegisteredGift}
              registeredGifts={registeredGifts}
              tableHeader
              activeCategory={this.props.activeCategory}
              deletePopup={this.props.deletePopup}
            />
          </div>
        }
        {registeredGiftCertificates.length > 0 && (
          <Fragment>
            <div className="row padBottom_six">
              <div className="col-xs-12">
                <div className='certi-regalo'> 
                  <div className='certi-regalo-title'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.certi.regalo.title.label')}</div>
                  <div className='certi-regalo-subtitle'>{commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.certi.regalo.subtitle.label')}</div>
                </div>
              </div>
            </div>
            <div className='giftCertificates'>
            <Template1
              updateGiftList={this.updateGiftList}
              sorting={this.props.sorting}
              storeElectronicGifts={this.storeElectronicGifts}
              makeIsChangeFalse={this.makeIsChangeFalse}
              handleGiftUnselect={this.handleGiftUnselect}
              handleGiftSelection={this.handleGiftSelection}
              registeredGiftList={this.state.registeredGiftList}
              isGiftSelected={this.state.isGiftSelected}
              eventId={this.props.eventId}
              handleSortAndFilter={this.props.handleSortAndFilter}
              eventStatus={this.props.eventStatus}
              categoryInfo={categoryInfoToRender}
              lables={this.props.lables}
              compareEventStatus={this.props.compareEventStatus}
              allowUpdate={this.props.allowUpdate}
              handleBulkAction={this.props.handleBulkAction}
              eventType={this.props.eventType}
              selectedGift={this.selectedGift}
              originalRegisteredGiftList={this.state.originalRegisteredGiftList}
              getPaginatedRegisteredGifts={this.props.getPaginatedRegisteredGifts}
              updateRegisteredGift={this.updateRegisteredGift}
              registeredGifts={registeredGiftCertificates}
              tableHeader={false}
              deletePopup={this.props.deletePopup}
            />
            </div>
          </Fragment>
        )}
        <ModalPopover
          modalId={this.state.modalId} isModal="true" modalClass="modal fade bs-example-modal-sm in"
          ref={confirmationModalForUpdate => this.confirmationModalForUpdate = confirmationModalForUpdate} header outerClass="modal-sm" footer={modalFooter}
        >
          <p>{this.state.confirmationMessage}</p>


        </ModalPopover>
      </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  location: state.routing.locationBeforeTransitions.pathname,
  eventStatus: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventStatus,
  eventDate: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventDate,
  eventId: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventId,
  eventType: state.giftList && state.giftList.data && state.giftList.data.eventSummaryInfo && state.giftList.data.eventSummaryInfo.eventInfo && state.giftList.data.eventSummaryInfo.eventInfo.eventType,
  printingDate: state.info && state.info.data && state.info.data.time,
});
const matchDispatchToProps = dispatch => bindActionCreators(
  {
    removeItemsFromGiftlist,
    changeDeliveryAddress,
    changeDeliveryMode,
    getRegisteredGiftList,
    // downloadAll,
  }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(RegalosRegistradosContent);
